import * as Comlink from 'comlink';

/** Singleton Comlink-wrapped worker. Disposing releases the proxy, terminates
 *  the worker, and resets state so the next `get()` spins up a fresh one —
 *  used when the worker dies (error/messageerror) or HMR replaces the module.
 *  The factory is a function so callers can pass `new URL(..., import.meta.url)`
 *  with their own module-graph resolution. */
export function makeWorkerSingleton<T>(create: () => Worker): {
  get: () => Comlink.Remote<T>;
  dispose: () => void;
} {
  let worker: Worker | null = null;
  let proxy: Comlink.Remote<T> | null = null;

  const dispose = () => {
    proxy?.[Comlink.releaseProxy]();
    worker?.terminate();
    proxy = null;
    worker = null;
  };

  const get = (): Comlink.Remote<T> => {
    if (!proxy) {
      worker = create();
      worker.addEventListener('error', dispose);
      worker.addEventListener('messageerror', dispose);
      proxy = Comlink.wrap<T>(worker);
    }
    return proxy;
  };

  return { get, dispose };
}
